module.exports = __webpack_public_path__ + "static/media/elevate-2.d4bc3cbd.png";